<template>
    <div>
        <div></div>
        <v-card flat>
            <v-card-text>
                This component is a reusable record picker contained within a dialog.<br/>
                It's helpful if you have a large list of items to select from.
                Also very useful if you need access to multiple columns when selecting a record.
            </v-card-text>
            <v-card-actions>
                <v-btn @click="dialogOpen">
                    Open
                </v-btn>
                <record-picker-dialog
                    :show.sync="show_dialog"
                    :input="sample_data"
                    :headers="headers"
                    item_key="value"
                    alphabetic_key="text"
                    v-model="selection"
                    multiple
                    enable_search
                    title="This Will Be The Title"
                    v-on:closeDialog="dialogClose"
                />
            </v-card-actions>
        </v-card>
    </div>

</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import SmartTable from "@/Generic/SmartTable";
import RecordPickerDialog from "@/Generic/RecordPickerDialog";

export default {
    name: "ExampleRecordPickerDialog",
    components: {
        RecordPickerDialog,
        AppLayout,
    },
    props: {
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'valuelists': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'input': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        }
    },
    data() {
        return {
            examplefile: this.input,
            show_dialog: false,
            sample_data: this.valuelists.EXAMPLE_FILES,
            selection: null,
        }
    },
    computed: {
        headers() {
            return [
                {value: 'value',            text: 'ID',             align: `start`,  sortable: true,     filterable: true},
                {value: 'text',             text: 'Name',           align: `start`,  sortable: true,     filterable: true},
            ]
        },
    },
    methods: {
        dialogOpen() {
            this.show_dialog = true
        },
        dialogClose: function() {
            this.show_dialog = false
        },
    },
}
</script>

<style>

</style>
